// extracted by mini-css-extract-plugin
export default {"tournamentsTable":"List_tournamentsTable__+stgU","descriptionCell":"List_descriptionCell__xDCBR"};